import { IonBadge, IonInput } from '@ionic/react';
import React, {useEffect, useState} from 'react';
import './NumberInput.css';

interface NumberInputProps {
  onIonChange:any;
  value:any;
  prefix?:any;
  suffix?:any;
  thousandSeparator?:any;
  decimalSeparator?:any;
  decimalScale?:any;
  allowNegative?:any;
  fixedDecimalScale?:any;
  thousandsGroupStyle?:any;
  format?:any;
  mask?:any;
  allowedDecimalSeparators?:any;
  allowEmptyFormatting?:any;
  isNumericString?:any;
  defaultValue?:any;
  readonly:any;
}

const NumberInput: React.FC<NumberInputProps> = ({ onIonChange,value
      ,prefix="",suffix="",thousandSeparator=false,decimalSeparator=".",decimalScale=0
      ,allowNegative=true,fixedDecimalScale=true,thousandsGroupStyle="thousand"
      ,format=undefined,mask=undefined
      ,allowedDecimalSeparators=undefined
      ,allowEmptyFormatting=true
      ,isNumericString=undefined
      ,defaultValue=0
      ,readonly=false}) => {

  const [state,setState] = useState({
    value: "",
    numAsString: "",
    mounted: false
  })
      
  var props:any

  const splitDecimal = (numStr:any, allowNegative:any=undefined) => {
    if ( allowNegative === void 0 ) allowNegative = true;
  
    var hasNagation = numStr[0] === '-';
    var addNegation = hasNagation && allowNegative;
    numStr = numStr.replace('-', '');
  
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
  
    return {
      beforeDecimal: beforeDecimal,
      afterDecimal: afterDecimal,
      hasNagation: hasNagation,
      addNegation: addNegation,
    };
  }
    
  const limitToScale = (numStr:any, scale:any, fixedDecimalScale:any) => {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';
    for (var i = 0; i <= scale - 1; i++) {
      str += numStr[i] || filler;
    }
    return str;
  }

  const applyThousandSeparator = (
    str:any,
    thousandSeparator:any,
    thousandsGroupStyle:any
  ) => {
    var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return (
      str.substring(0, index) +
      str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
    );
  }
  
  const getThousandsGroupRegex = (thousandsGroupStyle:any) => {
    switch (thousandsGroupStyle) {
      case 'lakh':
        return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
      case 'wan':
        return /(\d)(?=(\d{4})+(?!\d))/g;
      case 'thousand':
      default:
        return /(\d)(?=(\d{3})+(?!\d))/g;
    }
  }

  const fixLeadingZero = (numStr:any) => {
    if (!numStr) { return numStr; }
    var isNegative = numStr[0] === '-';
    if (isNegative) { numStr = numStr.substring(1, numStr.length); }
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
  
    return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
  }
  
  const getMaskAtIndex = (index:any,mask:any) => {
    if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }
  
    return mask[index] || ' ';
  };

  const formatWithPattern = (numStr:any,format:any,mask:any) => {
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || getMaskAtIndex(hashCount,mask);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  }

  const formatNumString = (numStr:any,allowEmptyFormatting=true,format:any=undefined,mask="") => {
    if ( numStr === void 0 ) numStr = '';
  
    var formattedValue = numStr;
  
    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = formatWithPattern(formattedValue,format,mask);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = formatAsNumber(formattedValue);
    }
  
    return formattedValue;
  
  }
  
  const formatAsNumber = (numStr:any) => {
//  console.log("formatAsNumber("+numStr+")")
    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
  
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
  
    // console.log("-hasDecimalSeparator:"+hasDecimalSeparator)
    // console.log("-beforeDecimal:"+beforeDecimal)
    // console.log("-afterDecimal:"+afterDecimal)
    // console.log("-addNegation:"+addNegation)

    //apply decimal precision if its defined
    if (decimalScale !== undefined) { afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale)}
  
    if(thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }
  
    // console.log("-decimalScale:"+decimalScale)
    // console.log("-beforeDecimal:"+beforeDecimal)
    // console.log("-afterDecimal:"+afterDecimal)

    //add prefix and suffix
    if(prefix) { beforeDecimal = prefix + beforeDecimal; }
    if(suffix) { afterDecimal = afterDecimal + suffix; }

    // console.log("-prefix:"+prefix)
    // console.log("-suffix:"+suffix)
  
    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    // console.log("-hasDecimalSeparator:"+hasDecimalSeparator)
    // console.log("-decimalSeparator:"+decimalSeparator)
    // console.log("-(hasDecimalSeparator && decimalSeparator || ''):"+(hasDecimalSeparator && decimalSeparator || ''))
  
    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    // console.log("-addNegation:"+addNegation)
    // console.log("-numStr:"+numStr)

    return numStr;
  }

  const setCaretPosition = (el:any, caretPos:any) => {
    //console.log("setCaretPosition("+caretPos+")")
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
      if (el.createTextRange) {
        //console.log("  el.createTextRange")
        var range = el.createTextRange();
        range.move('character', caretPos);
        range.select();
        return true;
      }
      // (el.selectionStart === 0 added for Firefox bug)
      if (el.selectionStart || el.selectionStart === 0) {
//        console.log("  el.selectionStart:"+el.selectionStart)
        el.focus();
//        console.log("  caretPos:"+caretPos)
        el.setSelectionRange(caretPos, caretPos);

        return true;
      }
  
      // fail city, fortunately this never happens (as far as I've tested) :)
      el.focus();
      return false;
    }
  }

  const setPatchedCaretPosition = (el:any, caretPos:any, currentValue:any) => {
    //console.log("setPatchedCaretPosition()")
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    setTimeout(function () {
      if(el.value === currentValue) { 
        setCaretPosition(el, caretPos); 
      }
    }, 0);
  }

  function charIsNumber(char:any) {
    return !!(char || '').match(/\d/);
  }

  function clamp(num:any, min:any, max:any) {
    return Math.min(Math.max(num, min), max);
  }
  
  const correctCaretPosition = (value:any, caretPos:any, direction:any=undefined) => {
    //console.log("correctCaretPosition("+value+","+caretPos+")")
    // var ref = this.props;
    // var prefix = ref.prefix;
    // var suffix = ref.suffix;
    // var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) { return caretPos; }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) { return caretPos; }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))) {
      caretLeftBound -= 1;
    }

    var goToLeft = !charIsNumber(value[caretRightBound])
    || (direction === 'left' && caretPos !== firstHashPosition)
    || (caretPos - caretLeftBound < caretRightBound - caretPos);

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  }

  const getSeparators = () => {
    //var ref = this.props;
    //var decimalSeparator = ref.decimalSeparator;
    //var ref$1 = this.props;
    // var thousandSeparator = ref$1.thousandSeparator;
    // var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    }
  }

  const getNumberRegex = (g:any, ignoreDecimalSeparator:any=false) => {
    // var ref = this.props;
    // var format = ref.format;
    // var decimalScale = ref.decimalScale;
    var ref$1 = getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + escapeRegExp(decimalSeparator) : ''), g ? 'g' : undefined);
  }

  const escapeRegExp = (str:any) => {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  }

  const getCaretPosition = (inputValue:any, formattedValue:any, caretPos:any) => {
    //console.log("getCaretPosition()")
    // var ref = this.props;
    // var format = ref.format;
    //var stateValue = this.state.value;
    var stateValue = 0;
    var numRegex = getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for(i=0; i<caretPos; i++){
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if(!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) { continue; }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) { continue; }

      //we are not using currentFormatChar because j can change here
      while(currentInputChar !== formattedValue[j] && j < formattedValue.length) { j++; }
      j++;
    }

    if ((typeof format === 'string' && !stateValue)) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = correctCaretPosition(formattedValue, j);

    return j;
  }

  const getCurrentCaretPosition = (el:any) => {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
    //console.log("getCurrentCaretPostion()")
    return Math.max(el.selectionStart, el.selectionEnd);
  }

  const removePrefixAndSuffix = (val:any) => {
    // var ref = this.props;
    // var format = ref.format;
    // var prefix = ref.prefix;
    // var suffix = ref.suffix;
//console.log("removePrefixAndSuffix(val:"+val+")")
    //remove prefix and suffix
    if (!format && val) {
      //console.log("format:"+format+",val:"+val)
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  }

  const removePatternFormatting = (val:any) => {
    // var ref = this.props;
    // var format = ref.format;
    var formatArray = format.split('#').filter(function (str:any) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i=0, ln=formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(/\d/g) || []).join('');
  }

  const getFloatString = (num:any) => {
    if ( num === void 0 ) num = '';

    // var ref = this.props;
    // var decimalScale = ref.decimalScale;
    var ref$1 = getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if(hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num  = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if(hasNegation) { num = '-' + num; }

    return num;
  }

  const removeFormatting = (val:any) => {
    // var ref = this.props;
    // var format = ref.format;
    // var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = removePrefixAndSuffix(val);
      val = getFloatString(val);
    } else if (typeof format === 'string') {
      val = removePatternFormatting(val);
    // } else if (typeof removeFormatting === 'function') { //condition need to be handled if format method is provide,
    //   val = removeFormatting(val);
    } else {
      val = (val.match(/\d/g) || []).join('');
    }
    return val;
  }

  const getValueObject = (formattedValue:any, numAsString:any) => {
    var floatValue = parseFloat(numAsString);
    
    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue
    }
  }

  const updateValue = (params:any) => {
      //console.log("updateValue()")
      var formattedValue = params.formattedValue;
      var input = params.input;
      var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
      var numAsString = params.numAsString;
      var caretPos = params.caretPos;
      // var ref = this.props;
      // var onValueChange = ref.onValueChange;
      var ref$1 = state;
      var lastValue = ref$1.value;

      //console.log("  input:"+input)
      // for(var a in input) {
      //   console.log("---input["+a+"]:"+input[a])
      // }
  
      if (input) {
        //set caret position, and value imperatively when element is provided
        if (setCaretPosition) {
  
          //calculate caret position if not defined
          if (!caretPos) {
            var inputValue = params.inputValue || input.value;
  
            var currentCaretPosition = getCurrentCaretPosition(input);
  
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */
            //console.log("  formattedValue:"+formattedValue)
            input.value = formattedValue;
  
            //get the caret position
            caretPos = getCaretPosition(inputValue, formattedValue, currentCaretPosition);
          }
          //console.log("  caretPos:"+caretPos)
          //set caret position
          setPatchedCaretPosition(input, caretPos, formattedValue);
        } else {
  /**
           * if we are not setting caret position set the value imperatively.
           * This is required on onBlur method
           */
          input.value = formattedValue;
        }
      }

      //calculate numeric string if not passed
      if (numAsString === undefined) {
        numAsString = removeFormatting(formattedValue);
      }

      //update state if value is changed
      if (formattedValue !== lastValue) {
//          console.log("setState("+formattedValue+","+numAsString+")")
          setState({ value : formattedValue, numAsString: numAsString, mounted:false});
          setInpValue(formattedValue)
          // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
          //onValueChange(getValueObject(formattedValue, numAsString));
          onIonChange(getValueObject(formattedValue, numAsString))
      }
      //console.log("update value finish")
  }

  const isNil = (val:any) => {
    return val === null || val === undefined;
  }

  const validateProps = () => {
    // var ref = this.props;
    // var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "))
      }
    }

  }

  const repeat = (str:any, count:any) => {
    return Array(count + 1).join(str)
  }

  const toNumericString = (num:any) => {
    num += ''; // typecast number to string
  
    // store the sign and remove it from the number.
    var sign = num[0] === '-' ? '-' : '';
    if (sign) { num = num.substring(1); }
  
    // split the number into cofficient and exponent
    var ref = num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
  
    // covert exponent to number;
    exponent = Number(exponent);
  
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent) { return sign + coefficient; }
  
    coefficient = coefficient.replace('.', '');
  
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */
    var decimalIndex = 1 + exponent;
  
    var coffiecientLn = coefficient.length;
  
    if (decimalIndex < 0) {
      // if decimal index is less then 0 add preceding 0s
      // add 1 as join will have
      coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
    } else if (decimalIndex >= coffiecientLn) {
      // if decimal index is less then 0 add leading 0s
      coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
    } else {
      // else add decimal point at proper index
      coefficient = (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
    }
  
    return sign + coefficient;
  }

  const roundToPrecision = (numStr:any, scale:any, fixedDecimalScale:any) => {
    //if number is empty don't do anything return empty string
    if (['', '-'].indexOf(numStr) !== -1) { return numStr; }
  
    var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
    var ref = splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNagation = ref.hasNagation;
    var floatValue = parseFloat(("0." + (afterDecimal || '0')));
    var floatValueStr =
      afterDecimal.length <= scale ? toNumericString(floatValue) : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split('.');
    var intPart = beforeDecimal
      .split('')
      .reverse()
      .reduce(function (roundedStr:any, current:any, idx:any) {
        if (roundedStr.length > idx) {
          return (
            (Number(roundedStr[0]) + Number(current)).toString() +
            roundedStr.substring(1, roundedStr.length)
          );
        }
        return current + roundedStr;
      }, roundedDecimalParts[0]);
  
    var decimalPart = limitToScale(
      roundedDecimalParts[1] || '',
      Math.min(scale, afterDecimal.length),
      fixedDecimalScale
    );
    var negation = hasNagation ? '-' : '';
    var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
    return ("" + negation + intPart + decimalSeparator + decimalPart);
  }

  const formatNegation = (value:any) => {
    if ( value === void 0 ) value         = '';

    // var ref = this.props;
    // var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  }

  const formatInput = (value:any) => {
    //console.log("  formatInput("+value+")")
    if ( value === void 0 ) value         = '';

    // var ref = this.props;
    // var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = removePrefixAndSuffix(value);
      value = formatNegation(value);
    }

    //console.log("    pass 2:"+value)

    //remove formatting from number
    value = removeFormatting(value);

    //console.log("    pass 3:"+value)

    return formatNumString(value);
  }

  const formatValueProp = (defaultValue:any=undefined) => {
    //console.log("formatValueProp()")
    // var ref = this.props;
    // var format = ref.format;
    // var decimalScale = ref.decimalScale;
    // var fixedDecimalScale = ref.fixedDecimalScale;
    // var allowEmptyFormatting = ref.allowEmptyFormatting;
    // var ref$1 = this.props;
    // var value = ref$1.value;
    // var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    //console.log("  pass 3")

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //console.log("  pass 4")

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //console.log("  pass 5")

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }
//console.log("  value:"+value);
//console.log("  isNumericString:"+isNumericString);
    var formattedValue = isNumericString ? formatNumString(value) : formatInput(value);
//console.log("  formattedValue:"+formattedValue);

    return formattedValue;
  }

  const updateValueIfRequired = (prevProps:any) => {
    //console.log("updateValueIfRequired()")
//    var ref = this;
//    var props = ref.props;
//    var state = ref.state;
//    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if(prevProps !== props) {
      //console.log('update')
      //validate props
      props = prevProps
      validateProps();

      //console.log("after validateProps:"+lastNumStr)
      var lastValueWithNewFormat = formatNumString(lastNumStr)
      //console.log("  formattedValue 1:"+formattedValue)

      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : formatValueProp()
      //console.log("  formattedValue 2:"+formattedValue)
      var numAsString = removeFormatting(formattedValue);

      //console.log("    formattedValue 3:"+formattedValue)
      //console.log("    numAsString:"+numAsString)

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        //console.log("update value")
        updateValue({ formattedValue: formattedValue, numAsString: numAsString, input: focusedElm });
      }
    }
  }

  const findChangedIndex = (prevValue:any, newValue:any) => {
    var i = 0,
      j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while (prevValue[i] === newValue[i] && i < prevLength) { i++; }
  
    //check what has been changed from last
    while (
      prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
      newLength - j > i &&
      prevLength - j > i
    ) {
      j++;
    }
  
    return { start: i, end: prevLength - j };
  }

  const [selectionBeforeInput, setSelectionBeforeInput] = useState({
    selectionStart: 0,
    selectionEnd: 0
  })
  const isCharacterAFormat = (caretPos:any ,value:any) => {
    // var ref = props;
    // var format = ref.format;
    // var prefix = ref.prefix;
    // var suffix = ref.suffix;
    // var decimalScale = ref.decimalScale;
    // var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (!format && (caretPos < prefix.length
      || caretPos >= value.length - suffix.length
      || (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  }

  const checkIfFormatGotDeleted = (start:any, end:any, value:any) => {
    for (var i = start; i < end; i++) {
      if (isCharacterAFormat(i, value)) { return true; }
    }
    return false;
  }

  const correctInputValue = (caretPos:any, lastValue:any, value  :any) => {
    // var ref = props;
    // var format = ref.format;
    // var allowNegative = ref.allowNegative;
    // var prefix = ref.prefix;
    // var suffix = ref.suffix;
    // var decimalScale = ref.decimalScale;
    var ref$1 = getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = state.numAsString || '';
    var ref$2 = selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (!format && start === end && allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1  ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length);
    }


    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    //if format got deleted reset the value to last value
    if (checkIfFormatGotDeleted(start, end, lastValue)) {
      value = lastValue;
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = removeFormatting(value);
      var ref$4 = splitDecimal(numericString, allowNegative);
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  }

  const [inpValue, setInpValue] = useState("")
  const [focusedElm, setFocusedElm] = useState()

  useEffect(() => {
    //console.log("useEffect()")

    var formattedValue = formatValueProp(value ? value : defaultValue)
    //console.log("   formattedValue:"+formattedValue)

    setState({
      value: formattedValue,
      numAsString: removeFormatting(formattedValue),
      mounted: false,
    })

    //console.log("   state.numAsString:"+state.numAsString)
    //console.log("  formattedValue:"+formattedValue)
    if (value) {
      setInpValue(formattedValue)
    } else {
      setInpValue("")
    }
  },[])

  useEffect(() => {
      //console.log("useEffect() inpValue:"+inpValue)
      //updateValueIfRequired(inpValue)
  }, [inpValue]);

  return (readonly ?
    <IonInput type="text" value=" " readonly={readonly}>
      <IonBadge color="medium">{inpValue}</IonBadge>
    </IonInput>
  :
    <IonInput type="text" value={inpValue} 
    onIonChange={(e: any) => {
        setFocusedElm(e.target.firstChild);
        if(e.target.firstChild?.value) {
          console.log(" if(focusedElm.value):"+inpValue+","+e.target.firstChild.value)
          //setInpValue(e.target.firstChild.value)
          var el = e.target.firstChild;
          var inputValue = el.value;
          // var ref = this;
          // var state = ref.state;
          // var props = ref.props;
          //var isAllowed = props.isAllowed;
          var lastValue = state.value || '';

          var currentCaretPosition = getCurrentCaretPosition(el);

          inputValue =  correctInputValue(currentCaretPosition, lastValue, inputValue);

          var formattedValue = formatInput(inputValue) || '';
          var numAsString = removeFormatting(formattedValue);

          //var valueObj = getValueObject(formattedValue, numAsString);
          //var isChangeAllowed = isAllowed(valueObj);
          var isChangeAllowed = true;

          if (!isChangeAllowed) {
            formattedValue = lastValue;
          }

          updateValue({ formattedValue: formattedValue, numAsString: numAsString, inputValue: inputValue, input: el });

          // if(isChangeAllowed) {
          //   props.onChange(e);
          // }
        }
    }}
    onIonFocus={(e:any) => {
        setFocusedElm(e.target.firstChild);
    }}
    onIonBlur={(e:any) => {
      /*
        var formattedValue = formatValueProp(e.target.firstChild.value)
        console.log("onIonBlur:"+e.target.value+","+formattedValue)
        setInpValue(formattedValue)
        */
    }}
    />
  )
}

export default NumberInput;
